module.exports = __webpack_public_path__ + "static/media/book.6720e0c4.svg";